import {
  FirstLoanOfferQueryParams,
  FirstLoanOfferResponse,
} from 'api/typegen/application/first-loan-offer/get';
import fetchWebApi from 'api/fetchWebApi';

const getFirstLoanOfferApiCall = async (
  params: FirstLoanOfferQueryParams,
): Promise<FirstLoanOfferResponse> =>
  fetchWebApi('/application/first-loan-offer', params);

export default getFirstLoanOfferApiCall;
